<div class="loginContent">
  <div class="signInCardStyle">
    <div class="loginContainer">
      <div class="divImage">
        <img class="logoImage" [src]="loginLogoPath" />
      </div>
      <div id="divContentLogIn">
        <abc-authentication-login></abc-authentication-login>
      </div>
    </div>
  </div>
</div>